(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-catalog"] && !Shopify.designMode) return;
  try {
    
  class BrandCatalogFilters {
    constructor(section) {
      this.section = section;
      this.buttons = Array.from(section.querySelectorAll('[data-filter-kind]'));
      this.items = Array.from(section.querySelectorAll('.brand-catalog__item'));
      this.zones = Array.from(section.querySelectorAll('[data-filter-zone]'));
      this.noResults = section.querySelector('[data-no-results]');
      this.status = section.querySelector('[data-filter-status]');
      this.materiaSelect = section.querySelector('[data-materia-select]');
      this.materiaSummary = section.querySelector('[data-materia-summary]');
      this.state = { materia: '', etapa: '' };
      this.buttons.forEach((button) => {
        button.addEventListener('click', () => this.select(button));
      });
      this.apply();
    }

    select(button) {
      const kind = button.dataset.filterKind;
      const value = button.dataset.filterValue || '';
      this.state[kind] = this.state[kind] === value && value !== '' ? '' : value;
      if (kind === 'materia' && this.materiaSelect) {
        this.materiaSelect.removeAttribute('open');
      }
      this.apply();
    }

    matches(item) {
      const materia = item.dataset.materia || '';
      const etapa = item.dataset.etapa || '';
      const materiaOk = this.state.materia === '' || materia === this.state.materia;
      const etapaOk = this.state.etapa === '' || etapa === this.state.etapa;
      return materiaOk && etapaOk;
    }

    apply() {
      let visible = 0;
      this.items.forEach((item) => {
        const show = this.matches(item);
        item.toggleAttribute('hidden', !show);
        if (show) visible += 1;
      });

      this.zones.forEach((zone) => {
        const anyVisible = Array.from(zone.querySelectorAll('.brand-catalog__item')).some(
          (item) => !item.hidden,
        );
        zone.closest('.brand-catalog__group').toggleAttribute('hidden', !anyVisible);
      });

      this.buttons.forEach((button) => {
        const active = (button.dataset.filterValue || '') === this.state[button.dataset.filterKind];
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });

      const labels = this.buttons
        .filter((button) => (button.dataset.filterValue || '') !== '' && (button.dataset.filterValue || '') === this.state[button.dataset.filterKind])
        .map((button) => button.textContent.trim());
      const statusText = labels.length ? labels.join(' · ') : this.section.dataset.allLabel;
      if (this.status) {
        this.status.textContent = `${this.section.dataset.selectedLabel}: ${statusText}`;
      }
      if (this.materiaSummary) {
        const materiaButton = this.buttons.find(
          (button) =>
            button.dataset.filterKind === 'materia' &&
            (button.dataset.filterValue || '') === this.state.materia,
        );
        this.materiaSummary.textContent = materiaButton?.textContent?.trim() || this.section.dataset.allLabel;
      }
      if (this.noResults) {
        this.noResults.hidden = visible > 0 || this.items.length === 0;
      }
    }
  }

  document.querySelectorAll('[data-brand-catalog]').forEach((section) => new BrandCatalogFilters(section));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
